<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'PAYEE_SECTOR.TITLE' | translate}}</h2>
    <!-- <ntr-add-button [openView]="'payee-sector-add-edit'"></ntr-add-button> -->

    <ntr-datatable [data]="data" [metaInfo]="metaInfo" [canDelete]="false" [entityTitle]="'payeeSector'" [modelView]="'payee-sector'" [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="['','name','code', 'higherSector']" 
    (onDeleteQuery)="deletePayeeSector($event)"></ntr-datatable>
</div>